module.exports = __webpack_public_path__ + "img/l.fa52bb8e.webp";